import { render, staticRenderFns } from "./ButtonSave.vue?vue&type=template&id=29246a2e&scoped=true&lang=html"
import script from "./ButtonSave.vue?vue&type=script&lang=js"
export * from "./ButtonSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../gestion-tache-vuejs-v2/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29246a2e",
  null
  
)

export default component.exports